import AppAuditer from "meta/features/audit/auditer";
export const useAuditer = () => {
    const audit = (application, menuItem, action, type, target, properties = { ordNo: null, account: null }) => {
        let appAuiditer = new AppAuditer(application, menuItem);
        return appAuiditer.writeCustomTypeAction(action, type, target, properties);
    };
    return { audit };
};
